package com.starparty.app.astro0.renderers

import com.starparty.app.astro0.DeepSkyField
import com.starparty.app.astro0.SP_Canvas
import com.starparty.app.astro0.Sky
import com.starparty.app.astro0.celestialobjects.DSO
import com.starparty.app.geometry.SP_Point

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
object DSOFieldRenderer {

    var visMagLimit = 60.0f
    val NO_TITLES = 0
    val FULL_TITLES = 1
    val ABBR_TITLES = 2


    fun getStarToolTipDescription(p: SP_Point, sky: Sky): String? {
        var text: String? = null
        val dso = getDSOUnderPoint(p, sky.deepSkyField)
        val starRenderer = DSORenderer()

        if (dso != null) {
            val dsoRenderer = DSORenderer()
            text = dsoRenderer.getToolTipText(dso, sky)
        }
        return text
    }

    fun getDSOStatusBarDescription(p: SP_Point, sky: Sky): String? {
        var text: String? = null
        val dso = getDSOUnderPoint(p, sky.deepSkyField)

        if (dso != null) {
            val dsoRenderer = DSORenderer()
            text = dsoRenderer.getStatusBarText(dso, sky)
        }
        return text
    }

    fun getDSOUnderPoint(p: SP_Point, field: DeepSkyField): DSO? {
        var rightOne: DSO? = null
        val renderer = DSORenderer()
        val dsos = field.dsos

        for (d in dsos!!.indices) {
            val dso = dsos!![d]
            if (dso.visMag < visMagLimit) {
                if (renderer.contains(dso, p)) {
                    rightOne = dso
                }
            }
        }
        return rightOne
    }

    fun paint(field: DeepSkyField, titleType: Int, g: SP_Canvas, rendererTheme: RendererTheme) {

        if (field.isShowingDSOs) {
            paintDSOs(field, titleType, g, rendererTheme)
        }
    }

    fun paintDSOs(field: DeepSkyField, titleType:Int, g: SP_Canvas, rendererTheme: RendererTheme) {

        val dsos = field.dsos
        val renderer = DSORenderer()
        for (d in dsos.indices) {
            val dso = dsos[d]
            // if (dso.visMag <= itsVisMag) {
            renderer.paint(dso, titleType, g, rendererTheme)
            //}
        }
    }


    init {

    }
}